/**
 * @author Ketan Shetye
 * @created 2025-11-24
 * @description client admin routing
 */

import { WorkflowApplicationListViewComponent } from 'src/app/views/admin/workflow-applications/workflow-application-list-view/workflow-application-list-view.component';

import {

  inject
} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Routes
} from '@angular/router';
import { ContactsEditorComponent } from 'src/app/views/admin/contacts-editor/contacts-editor.component';
import { ExternalDataConnectionsEditorComponent } from 'src/app/views/admin/external-data-connections-editor/external-data-connections-editor.component';
import { RoleEditorComponent } from 'src/app/views/admin/role-editor/role-editor.component';
import { MapServicesEditorComponent } from 'src/app/views/admin/map-services-editor/map-services-editor.component';
import { UserEditorComponent } from 'src/app/views/admin/user-editor/user-editor.component';
import { ClientDetailViewComponent } from 'src/app/views/admin/client-editor/client-detail/client-detail.component';
import { MapServiceListViewComponent } from 'src/app/views/admin/map-services-editor/map-service-list-view/map-service-list-view.component';
import { MapServiceDetailViewComponent } from 'src/app/views/admin/map-services-editor/map-service-detail-view/map-service-detail-view.component';
import { ExternalDataConnectionsListViewComponent } from 'src/app/views/admin/external-data-connections-editor/external-data-connections-list-view/external-data-connections-list-view.component';
import { ExternalDataConnectionsDetailViewComponent } from 'src/app/views/admin/external-data-connections-editor/external-data-connections-detail-view/external-data-connections-detail-view.component';
import { UserListViewComponent } from 'src/app/views/admin/user-editor/user-list-view/user-list-view.component';
import { UserDetailViewComponent } from 'src/app/views/admin/user-editor/user-detail-view/user-detail-view.component';
import { WorkflowSettingsEditorComponent } from 'src/app/components/workflow/workflow-settings-editor/workflow-settings-editor.component';
import { WorkflowListViewComponent } from 'src/app/views/admin/workflow-editor/workflow-list-view/workflow-list-view.component';
import { RoleListViewComponent } from 'src/app/views/admin/role-editor/role-list-view/role-list-view.component';
import { RoleDetailViewComponent } from 'src/app/views/admin/role-editor/role-detail-view/role-detail-view.component';
import {
  ActionGuard,
  ActionsGuard,
  GeopermitLayoutGuard,
  RenewalApplicationViewDetailsLayoutGaurd
} from 'src/app/services/auth.guard';
import { PaymentAccountEditorComponent } from 'src/app/views/admin/payment-account-editor/payment-account-editor.component';
import { PaymentAccountDetailViewComponent } from 'src/app/views/admin/payment-account-editor/payment-account-detail-view/payment-account-detail-view.component';
import { PaymentAccountListViewComponent } from 'src/app/views/admin/payment-account-editor/payment-account-list-view/payment-account-list-view.component';
import { Actions } from 'src/app/models';
import { ContactListViewComponent } from 'src/app/views/admin/contacts-editor/contact-list-view/contact-list-view.component';
import { ContactDetailViewComponent } from 'src/app/views/admin/contacts-editor/contact-detail-view/contact-detail-view.component';
import { WorkflowExportComponent } from 'src/app/components/reports/workflow-export/workflow-export.component';
import { ClientAdminComponent } from 'src/app/views/master-views/admin.view/client-admin/client-admin.component';
import { WorkflowDetailsViewComponent } from 'src/app/views/admin/workflow-details/workflow-details-view/workflow-details-view.component';
import { ContractorTypeListViewComponent } from 'src/app/views/admin/contractor-editor/contractor-type-list-view/contractor-type-list-view.component';
import { ContractorTypeDetailsViewComponent } from 'src/app/views/admin/contractor-editor/contractor-type-details-view/contractor-type-details-view.component';
import { ContractorTypeEditorViewComponent } from 'src/app/views/admin/contractor-editor/contractor-type-editor-view/contractor-type-editor-view.component';
import { ContractorSearchComponent } from 'src/app/views/admin/contractor-search/contractor-search.component';
import { InspectionsQueueComponent } from 'src/app/views/admin/inspections/inspections-queue/inspections-queue.component';
import { ContractorRegistrationDetailsComponent } from 'src/app/components/contractors/contractor-registration-details/contractor-registration-details.component';
import { InspectionDetailsComponent } from 'src/app/components/inspections/inspection-details/inspection-details.component';
import { AssignedInspectionsViewComponent } from 'src/app/views/admin/inspections/assigned-inspections/assigned-inspections.component';
import { WorkflowApplicationSearchViewComponent } from 'src/app/views/admin/workflow-applications/workflow-application-search-view/workflow-application-search-view.component';
import { FinancialComponent } from 'src/app/views/reports/financial/financial.component';
import { ContractorsReportComponent } from 'src/app/views/reports/contractors-report/contractors-report.component';
import { PermitsReportComponent } from 'src/app/views/reports/permits-report/permits-report.component';
import { TagEditorComponent } from 'src/app/views/admin/tag-editor/tag-editor.component';
import { CustomListEditorComponent } from 'src/app/views/admin/custom-list-editor/custom-list-editor.component';
import { CustomListDetailViewComponent } from 'src/app/views/admin/custom-list-editor/custom-list-detail-view/custom-list-detail-view.component';
import { CustomListListViewComponent } from 'src/app/views/admin/custom-list-editor/custom-list-list-view/custom-list-list-view.component';
import { WorkflowApplicationPreviousSystemListViewComponent } from 'src/app/views/admin/workflow-applications/workflow-application-previous-system-list-view/workflow-application-previous-system-list-view.component';
import { RenewalListComponent } from 'src/app/components/renewals/renewal-list/renewal-list.component';
import { RenewalDetailsComponent } from 'src/app/components/renewals/renewal-details/renewal-details.component';
import { WorkFlowPreviousSytemImportComponent } from 'src/app/components/workflow/workflow-previous-sytem-import/workflow-previous-sytem-import.component';
import { AgendaTypeListComponent } from 'src/app/views/admin/agendas/agenda-type-list/agenda-type-list.component';
import { AgendaListComponent } from 'src/app/views/admin/agendas/agenda-list/agenda-list.component';
import { AgendaSettingsEditorComponent } from 'src/app/views/admin/agendas/agenda-settings-editor/agenda-settings-editor.component';
import { AgendaViewComponent } from 'src/app/views/admin/agendas/agenda-view/agenda-view.component';
import { CustomReportListComponent } from 'src/app/components/reports/custom-report-list/custom-report-list.component';
import { CustomReportInputComponent } from 'src/app/components/reports/custom-report-input/custom-report-input.component';
import { InviteUserComponent } from 'src/app/components/security/invite-user/invite-user.component';
import { DatasetDesignerComponent } from 'src/app/components/reports/dataset-designer/dataset-designer.component';
import { DatasetListComponent } from 'src/app/components/reports/dataset-list/dataset-list.component';
import { WorkflowApplicationSearchByFeatureViewComponent } from 'src/app/views/admin/workflow-applications/workflow-application-search-by-feature-view/workflow-application-search-by-feature-view.component';
import { HelpViewComponent } from 'src/app/views/master-views/admin.view/client-admin/help-view/help-view.component';
import { PaymentSettingsComponent } from 'src/app/views/admin/payment-settings/payment-settings.component';
import { FeeRecipientsEditorComponent } from 'src/app/views/admin/fee-recipients-editor/fee-recipients-editor.component';
import { ClientEmailSettingsComponent } from 'src/app/views/admin/client-editor/client-email-settings/client-email-settings.component';
import { EmailFootersListComponent } from 'src/app/views/admin/email-footers-list/email-footers-list.component';
import { TemplateLibrarySearchComponent } from 'src/app/components/workflow/template-library/template-library-search/template-library-search.component';
import { MapWorkflowSettingsComponent } from 'src/app/components/workflow/template-library/map-workflow-settings/map-workflow-settings.component';
import { CopyWorkflowSettingsComponent } from 'src/app/components/workflow/copy-workflow-settings/copy-workflow-settings.component';
import { PendingChangesGuard } from 'src/app/services/pending-changes.guard';
import { ClientDepartmentListComponent } from 'src/app/views/admin/client-editor/client-department-list/client-department-list.component';
import { ClientDepartmentDetailComponent } from 'src/app/views/admin/client-editor/client-department-detail/client-department-detail.component';
import { ContractorDetailViewComponent } from 'src/app/views/admin/contractor-editor/contractor-detail-view/contractor-detail-view.component';
import { WorkflowMigrationComponent } from 'src/app/views/admin/workflow-migration/workflow-migration.component';
import { MigrationProcessingCreateComponent } from 'src/app/views/admin/migration-processing-create/migration-processing-create.component';



export const ClientAdminRoutes: Routes = [
  {
          path: 'jurisdiction/:clientId',
          component: ClientAdminComponent,
          canActivate:[GeopermitLayoutGuard],
          children: [
            {
              path: '',
              redirectTo: 'workflows',
              pathMatch: 'full'
            },
            {
              path: 'workflows',
              children: [
                {
                  path: 'list',
                  component: WorkflowListViewComponent
                  // canActivate: [ActionGuard],
                  // data: {
                  //   action: Actions.WORKFLOW_VIEW
                  // }
                },
                {
                  path: '',
                  redirectTo: 'list',
                  pathMatch: 'full'
                },
                {
                  path: 'edit/:workflowId',
                  component: WorkflowSettingsEditorComponent,
                  data: {
                    clientMode: true
                  }
                },
                {
                  path: 'details/:workflowId',
                  component: WorkflowDetailsViewComponent
                },
                {
                  path: 'add',
                  component: WorkflowSettingsEditorComponent,
                  data: {
                    clientMode: true
                  }
                },
                {
                  path: 'template-library',
                  component: TemplateLibrarySearchComponent
                },
                {
                  path: 'import/:workflowId',
                  component: MapWorkflowSettingsComponent,
                  canDeactivate: [PendingChangesGuard]
                },
                {
                  path: 'import/:workflowId/:workflowSaveId',
                  component: MapWorkflowSettingsComponent,
                  canDeactivate: [PendingChangesGuard]
                },
                {
                  path: 'copy/:workflowId',
                  component: CopyWorkflowSettingsComponent
                },
                {
                  path: 'copy/:workflowId/resume/:workflowSaveId',
                  component: MapWorkflowSettingsComponent,
                  canDeactivate: [PendingChangesGuard]
                }
              ]
            },
            {
              path: 'workflow-applications',
              children: [
                {
                  path: '',
                  redirectTo: 'search',
                  pathMatch: 'full'
                },
                {
                  path: 'search',
                  component: WorkflowApplicationSearchViewComponent
                },
                {
                  path: 'search-feature',
                  component: WorkflowApplicationSearchByFeatureViewComponent
                },
                {
                  path: 'list',
                  component: WorkflowApplicationListViewComponent
                },
                {
                  path: 'previous-system-list',
                  component: WorkflowApplicationPreviousSystemListViewComponent
                }
              ]
            },
            {
              path: 'renewals',
              children: [
                {
                  path: 'list',
                  component: RenewalListComponent
                },
                {
                  path: 'details/:registrationId',
                  component: RenewalDetailsComponent,
                  canActivate:[RenewalApplicationViewDetailsLayoutGaurd]
                }
              ]
            },
            {
              path: 'contractors',
              children: [
                {
                  path: 'types',
                  children: [
                    {
                      path: '',
                      redirectTo: 'list',
                      pathMatch: 'full'
                    },
                    {
                      path: 'list',
                      component: ContractorTypeListViewComponent
                    },
                    {
                      path: 'edit/:contractorTypeId',
                      component: ContractorTypeEditorViewComponent
                    },
                    {
                      path: 'details/:contractorTypeId',
                      component: ContractorTypeDetailsViewComponent
                    },
                    {
                      path: 'add',
                      component: ContractorTypeEditorViewComponent
                    }
                  ]
                },
                {
                  path: 'search',
                  component: ContractorSearchComponent
                },
                {
                  path: 'contractor-profile/:contractorId',
                  component: ContractorDetailViewComponent
                },
                {
                  path: 'registration-details/:registrationId',
                  component: ContractorRegistrationDetailsComponent
                },
                {
                  path: '',
                  redirectTo: 'types',
                  pathMatch: 'full'
                }
              ]
            },
            {
              path: 'inspections',

              children: [
                {
                  path: 'list',
                  component: InspectionsQueueComponent
                },
                {
                  path: '',
                  redirectTo: 'list',
                  pathMatch: 'full'
                },
                {
                  path: 'details/:inspectionId',
                  component: InspectionDetailsComponent
                },
                {
                  path: 'assignedInspections',
                  component: AssignedInspectionsViewComponent
                }
              ]
            },
            {
              path: 'reports',
              children: [
                {
                  path: '',
                  redirectTo: 'financial',
                  pathMatch: 'full'
                },
                {
                  path: 'financial',
                  component: FinancialComponent,
                  canActivate: [
                    (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
                      inject(ActionGuard).canActivate(next, state)
                  ],
                  data: {
                    action: Actions.REPORT_PAYMENT_TRANSACTION_VIEW // TODO: update with proper permissions
                  }
                },
                {
                  path: 'contractors',
                  component: ContractorsReportComponent,
                  canActivate: [
                    (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
                      inject(ActionGuard).canActivate(next, state)
                  ],
                  data: {
                    action: Actions.REPORT_PAYMENT_TRANSACTION_VIEW // TODO: update with proper permissions
                  }
                },
                {
                  path: 'permits',
                  component: PermitsReportComponent,
                  canActivate: [
                    (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
                      inject(ActionGuard).canActivate(next, state)
                  ],
                  data: {
                    action: Actions.REPORT_PAYMENT_TRANSACTION_VIEW // TODO: update with proper permissions
                  }
                },
                {
                  path: 'export',
                  component: WorkflowExportComponent,
                  canActivate: [
                    (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
                      inject(ActionGuard).canActivate(next, state)
                  ],
                  data: {
                    action: Actions.REPORT_DATA_EXPORT_VIEW
                  }
                },
                {
                  path: 'custom-reports',
                  component: CustomReportListComponent,
                  canActivate: [
                    (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
                      inject(ActionGuard).canActivate(next, state)
                  ],
                  data: {
                    action: Actions.VIEW_CUSTOM_REPORTS
                  }
                },
                {
                  path: 'custom-report/:reportId',
                  component: CustomReportInputComponent
                },
                {
                  path: 'data-sets',
                  component: DatasetListComponent
                },
                {
                  path: 'data-set/:dataSetId',
                  component: DatasetDesignerComponent
                }
              ]
            },
            {
              path: 'meetings',
              children: [
                {
                  path: 'agenda-types',
                  canActivate: [
                    (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
                      inject(ActionsGuard).canActivate(next, state)
                  ],
                  data: {
                    actions: Actions.AGENDA_ACTIONS
                  },
                  children: [
                    {
                      path: 'list',
                      component: AgendaTypeListComponent
                    },
                    {
                      path: 'agenda-type/:agendaTypeId',
                      component: AgendaListComponent
                    },

                    {
                      path: 'agenda-type/:agendaTypeId/edit-agenda/:agendaId',
                      component: AgendaSettingsEditorComponent,
                      canActivate: [
                        (
                          next: ActivatedRouteSnapshot,
                          state: RouterStateSnapshot
                        ) => inject(ActionsGuard).canActivate(next, state)
                      ],
                      data: {
                        actions: [Actions.DO_ANYTHING, Actions.MANAGE_AGENDAS]
                      }
                    },
                    {
                      path: 'agenda-type/:agendaTypeId/add-agenda',
                      component: AgendaSettingsEditorComponent,
                      canActivate: [
                        (
                          next: ActivatedRouteSnapshot,
                          state: RouterStateSnapshot
                        ) => inject(ActionsGuard).canActivate(next, state)
                      ],
                      data: {
                        actions: [Actions.DO_ANYTHING, Actions.MANAGE_AGENDAS]
                      }
                    },
                    {
                      path: 'agenda-type/:agendaTypeId/view-agenda/:agendaId',
                      component: AgendaViewComponent
                    },
                    {
                      path: '',
                      redirectTo: 'list',
                      pathMatch: 'full'
                    }
                  ]
                }
              ]
            },
            {
              path: 'users',
              component: UserEditorComponent,
              children: [
                {
                  path: 'list',
                  component: UserListViewComponent
                },
                {
                  path: 'edit/:userId',
                  component: UserDetailViewComponent
                },
                {
                  path: 'roles',
                  component: RoleEditorComponent,
                  children: [
                    {
                      path: 'list',
                      component: RoleListViewComponent
                    },
                    {
                      path: 'edit/:id',
                      component: RoleDetailViewComponent
                    },
                    {
                      path: 'add',
                      component: RoleDetailViewComponent
                    },
                    {
                      path: '',
                      redirectTo: 'list',
                      pathMatch: 'full'
                    }
                  ]
                },
                {
                  path: 'invitations',
                  children: [
                    {
                      path: 'add',
                      component: InviteUserComponent
                    },
                    {
                      path: '',
                      redirectTo: 'add',
                      pathMatch: 'full'
                    }
                  ]
                },
                {
                  path: '',
                  redirectTo: 'list',
                  pathMatch: 'full'
                }
              ]
            },
            {
              path: 'settings',
              children: [
                {
                  path: '',
                  redirectTo: 'general',
                  pathMatch: 'full'
                },
                {
                  path: 'general',
                  component: ClientDetailViewComponent
                },
                {
                  path: 'departments',
                  children: [
                    {
                      path: 'list',
                      component: ClientDepartmentListComponent
                    },
                    {
                      path: 'edit/:id',
                      component: ClientDepartmentDetailComponent
                    },
                    {
                      path: 'add',
                      component: ClientDepartmentDetailComponent
                    },
                    {
                      path: ':id',
                      component: ClientDepartmentDetailComponent
                    },
                    {
                      path: '',
                      component: ClientDepartmentListComponent,
                      pathMatch: 'full'
                    }
                  ]
                },
                {
                  path: 'import-previous-system',
                  component: WorkFlowPreviousSytemImportComponent
                },
                {
                  path: 'workflow-migration',
                  component: WorkflowMigrationComponent,
                  canActivate: [ActionGuard],
                  data: {
                    action: Actions.DO_ANYTHING
                  }
                },
                {
                  path: 'workflow-migration/create',
                  component: MigrationProcessingCreateComponent,
                  canActivate: [ActionGuard],
                  data: {
                    action: Actions.DO_ANYTHING
                  }
                },
                {
                  path: 'maps',
                  component: MapServicesEditorComponent,
                  children: [
                    {
                      path: 'list',
                      component: MapServiceListViewComponent
                    },
                    {
                      path: 'edit/:id',
                      component: MapServiceDetailViewComponent
                    },
                    {
                      path: 'add',
                      component: MapServiceDetailViewComponent
                    },
                    {
                      path: '',
                      redirectTo: 'list',
                      pathMatch: 'full'
                    }
                  ]
                },
                {
                  path: 'tags',
                  component: TagEditorComponent,
                  data: {
                    clientMode: true
                  }
                },
                {
                  path: 'payment-settings',
                  component: PaymentSettingsComponent,
                  children: [
                    {
                      path: 'payment-accounts',
                      component: PaymentAccountEditorComponent,
                      children: [
                        {
                          path: 'list',
                          component: PaymentAccountListViewComponent
                        },
                        {
                          path: 'edit/:paymentAccountId',
                          component: PaymentAccountDetailViewComponent
                        },
                        {
                          path: 'add',
                          component: PaymentAccountDetailViewComponent
                        },
                        {
                          path: '',
                          redirectTo: 'list',
                          pathMatch: 'full'
                        }
                      ]
                    },
                    {
                      path: 'fee-recipients',
                      component: FeeRecipientsEditorComponent
                    },
                    {
                      path: '',
                      redirectTo: 'payment-accounts',
                      pathMatch: 'full'
                    }
                  ]
                },
                {
                  path: 'data',
                  component: ExternalDataConnectionsEditorComponent,
                  children: [
                    {
                      path: 'list',
                      component: ExternalDataConnectionsListViewComponent
                    },
                    {
                      path: 'edit/:id',
                      component: ExternalDataConnectionsDetailViewComponent
                    },
                    {
                      path: 'add',
                      component: ExternalDataConnectionsDetailViewComponent
                    },
                    {
                      path: '',
                      redirectTo: 'list',
                      pathMatch: 'full'
                    }
                  ]
                },
                {
                  path: 'lists',
                  component: CustomListEditorComponent,
                  children: [
                    {
                      path: 'list',
                      component: CustomListListViewComponent
                    },
                    {
                      path: 'edit/:id',
                      component: CustomListDetailViewComponent
                    },
                    {
                      path: 'add',
                      component: CustomListDetailViewComponent
                    },
                    {
                      path: '',
                      redirectTo: 'list',
                      pathMatch: 'full'
                    }
                  ]
                },
                {
                  path: 'email-footers',
                  component: EmailFootersListComponent
                },
                {
                  path: 'contacts',
                  component: ContactsEditorComponent,
                  children: [
                    {
                      path: 'list',
                      component: ContactListViewComponent
                    },
                    {
                      path: 'edit/:id',
                      component: ContactDetailViewComponent
                    },
                    {
                      path: 'add',
                      component: ContactDetailViewComponent
                    },
                    {
                      path: '',
                      redirectTo: 'list',
                      pathMatch: 'full'
                    }
                  ]
                },
                {
                  path: 'email-settings',
                  component: ClientEmailSettingsComponent,
                  data: {
                    clientMode: true
                  }
                }
              ]
            },
            {
              path: 'help',
              component: HelpViewComponent
            }
          ]
        }
];
